import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = { reservationId: number };
type Response = {
  minEarnings: number;
  maxEarnings: number;
};

export const useSubscriptionEstimatedEarnings = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['subscriptions/estimated-earnings'],
  fetcher: ({ reservationId }) => {
    return client
      .get(`v2/internal/partners/subscriptions/estimated-earnings`, {
        params: { reservation_id: reservationId },
      })
      .then((response) => {
        return response.data.data;
      });
  },
});
